import { MijnRoute } from '../mijn-navigatie.model';

export const BUSINESS_CUSTOMER_BLOCKED: MijnRoute = {
    path: 'zakelijk-geblokkeerd',
    navigationEvent: 'toZakelijkGeblokkeerd',
    regex: /^\/zakelijk-geblokkeerd$/
};
